"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _InputBase = _interopRequireDefault(require("../InputBase"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["className", "value", "setValue", "lastFour", "showHide"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
(function _() {
  var styles = ".InputSocialSecurity__mask {\n  color: transparent;\n  caret-color: #424242;\n}\n.InputSocialSecurity__mask:focus {\n  color: transparent;\n}\n.InputSocialSecurity__mask_for_value {\n  position: absolute;\n  pointer-events: none;\n  left: 1rem;\n  top: 50%;\n  transform: translateY(-50%);\n  background: transparent;\n  font-size: 1rem;\n  border: 0;\n  color: #424242;\n  display: flex;\n  width: calc(100% - 2rem);\n  padding: 0.75rem 0rem;\n  border: none;\n  font-size: 1rem;\n  line-height: 1.5rem;\n  appearance: none;\n  box-sizing: border-box;\n  outline: 0;\n}";
  var fileName = "InputSocialSecurity_InputSocialSecurity";
  var element = document.querySelector("style[data-sass-component='InputSocialSecurity_InputSocialSecurity']");
  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
var InputSocialSecurity = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value,
    _setValue = _ref.setValue,
    _ref$lastFour = _ref.lastFour,
    lastFour = _ref$lastFour === void 0 ? false : _ref$lastFour,
    showHide = _ref.showHide,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var getRawVal = function getRawVal(ssn) {
    var rawVal = ssn.replace(/[^0-9]/g, '');
    return rawVal;
  };
  var isSsnValid = function isSsnValid(val) {
    if (![4, 11].includes(val.length)) {
      return false;
    }
    return true;
  };
  var formatSsn = function formatSsn(ssn) {
    var onlyNumbers = getRawVal(ssn);
    var createFormat = onlyNumbers.length < 4 || lastFour ? onlyNumbers : onlyNumbers.length > 3 && onlyNumbers.length <= 5 ? "".concat(onlyNumbers.slice(0, 3), "-").concat(onlyNumbers.slice(3)) : "".concat(onlyNumbers.slice(0, 3), "-").concat(onlyNumbers.slice(3, 5), "-").concat(onlyNumbers.slice(5));
    return createFormat;
  };
  var _useState = (0, _react.useState)('text'),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    iType = _useState2[0],
    setIType = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    showValue = _useState4[0],
    setShowValue = _useState4[1];
  var _useState5 = (0, _react.useState)(formatSsn(value)),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    format = _useState6[0],
    setFormat = _useState6[1];
  var maskedValue = /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
    value: format.replace(/[0-9]/g, '•'),
    onChange: function onChange(e) {
      return _setValue(formatSsn(e.target.value));
    },
    className: "InputSocialSecurity__mask_for_value"
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_InputBase["default"], _objectSpread(_objectSpread({}, rest), {}, {
    autoComplete: "off",
    type: !showHide ? iType : showValue ? 'text' : 'password',
    inputClass: showHide && !showValue ? 'InputSocialSecurity__mask' : '',
    className: "InputSocialSecurity ".concat(className),
    value: format,
    ref: ref,
    minLength: 0,
    maxLength: lastFour ? 4 : 11,
    formatValue: formatSsn,
    isValid: isSsnValid,
    onBlur: function onBlur() {
      setIType('password');
    },
    onFocus: function onFocus() {
      if (!showHide || showHide && showValue) {
        setIType('text');
      }
    },
    showHide: showHide ? _objectSpread(_objectSpread({}, showHide), {}, {
      callback: setShowValue,
      maskedValue: maskedValue
    }) : undefined,
    setValue: function setValue(ssn) {
      setFormat(formatSsn(ssn));
      _setValue(getRawVal(ssn));
    }
  }));
});
InputSocialSecurity.displayName = 'InputSocialSecurity';
var _default = InputSocialSecurity;
exports["default"] = _default;